<template>
	<div class="">
		<img style="height: 706px;position: absolute;top: 160px;z-index: -1;left: 0;right: 0;width: 100%;"
			src="@/assets/img/top_bg.png" alt="">
		<div class="main_w mar_auto" style="min-height: 500px; padding-top: 20px;">
			<!-- 考试头部 -->
			<div class="exam-header flex_between m-b-20" v-if="!submitted">
				<div>
					<span class="font_weight font_s20 main_color">{{ paperTitle }}</span>
					<el-tag class="m-l-10" size="small">第 {{ currentIndex + 1 }}/{{ questions.length }} 题</el-tag>
				</div>
				<div class="flex_align" v-if="timeLimit > 0">
					<i class="el-icon-time" style="color: #E6A23C; margin-right: 5px;"></i>
					<span :class="{'color_red': remainTime < 60}" class="font_weight">{{ formatTime(remainTime) }}</span>
				</div>
			</div>

			<!-- 加载中 -->
			<div v-if="loading" class="text_c p-30" v-loading="true" style="min-height: 300px;"></div>

			<!-- 答题区域 -->
			<div v-if="!loading && !submitted && questions.length > 0">
				<el-card class="question-card m-b-20">
					<div class="m-b-15">
						<el-tag size="mini" :type="getTypeTag(currentQuestion.type)" class="m-r-10">
							{{ getTypeName(currentQuestion.type) }}
						</el-tag>
						<span class="color_999 font_s12">（{{ currentQuestion.score || 5 }}分）</span>
					</div>
					<div class="font_s16 m-b-20 font_weight question-title">
						{{ currentIndex + 1 }}. {{ currentQuestion.title }}
					</div>

					<!-- 判断题 -->
					<div v-if="currentQuestion.type == 'judge'">
						<div v-for="opt in judgeOptions" :key="opt.value"
							:class="['option-item', { 'option-selected': answers[currentQuestion.id] === opt.value }]"
							@click="selectAnswer(currentQuestion.id, opt.value)">
							<span class="option-label">{{ opt.label }}</span>
							<span>{{ opt.text }}</span>
						</div>
					</div>

					<!-- 单选题 -->
					<div v-if="currentQuestion.type == 'single'">
						<div v-for="(opt, oi) in currentQuestion.options" :key="oi"
							:class="['option-item', { 'option-selected': answers[currentQuestion.id] === opt.key }]"
							@click="selectAnswer(currentQuestion.id, opt.key)">
							<span class="option-label">{{ opt.key }}</span>
							<span>{{ opt.value }}</span>
						</div>
					</div>

					<!-- 多选/不定项 -->
					<div v-if="currentQuestion.type == 'multi' || currentQuestion.type == 'uncertain'">
						<div v-for="(opt, oi) in currentQuestion.options" :key="oi"
							:class="['option-item', { 'option-selected': (answers[currentQuestion.id] || []).includes(opt.key) }]"
							@click="toggleMultiAnswer(currentQuestion.id, opt.key)">
							<span class="option-label">{{ opt.key }}</span>
							<span>{{ opt.value }}</span>
						</div>
						<p class="color_999 font_s12 m-t-10">
							<i class="el-icon-info"></i>
							{{ currentQuestion.type == 'multi' ? '多选题，请选择两个或以上选项' : '不定项选择，可选一个或多个' }}
						</p>
					</div>
				</el-card>

				<!-- 操作按钮 -->
				<div class="flex_between m-b-20">
					<el-button @click="prevQuestion" :disabled="currentIndex === 0" icon="el-icon-arrow-left">
						上一题
					</el-button>
					<div>
						<el-button type="text" @click="showAnswerCard = true">
							<i class="el-icon-menu"></i> 答题卡
						</el-button>
					</div>
					<div>
						<el-button v-if="currentIndex < questions.length - 1" type="primary" @click="nextQuestion"
							style="background-color: #163F88; border-color: #163F88;">
							下一题 <i class="el-icon-arrow-right"></i>
						</el-button>
						<el-button v-else type="success" @click="confirmSubmit">
							<i class="el-icon-check"></i> 交卷
						</el-button>
					</div>
				</div>
			</div>

			<!-- 答题卡弹窗 -->
			<el-dialog title="答题卡" :visible.sync="showAnswerCard" width="500px">
				<div class="answer-card-grid">
					<div v-for="(q, qi) in questions" :key="qi"
						:class="['answer-card-item', { 'answered': isAnswered(q.id), 'current': qi === currentIndex }]"
						@click="jumpToQuestion(qi)">
						{{ qi + 1 }}
					</div>
				</div>
				<div class="m-t-15 flex_between">
					<div>
						<span class="answer-card-item answered" style="display:inline-block;width:20px;height:20px;line-height:20px;font-size:10px;">1</span>
						<span class="font_s12 color_666"> 已答</span>
						<span class="answer-card-item" style="display:inline-block;width:20px;height:20px;line-height:20px;font-size:10px;margin-left:15px;">2</span>
						<span class="font_s12 color_666"> 未答</span>
					</div>
					<span class="font_s14">已答 {{ answeredCount }}/{{ questions.length }}</span>
				</div>
			</el-dialog>

			<!-- 考试结果 -->
			<div v-if="submitted" class="text_c">
				<el-card class="result-card mar_auto" style="max-width: 600px;">
					<div style="padding: 30px 0;">
						<i :class="score >= passScore ? 'el-icon-success' : 'el-icon-error'"
							:style="{ fontSize: '80px', color: score >= passScore ? '#67C23A' : '#F56C6C' }"></i>
						<div class="font_s24 font_weight m-t-20">
							{{ score >= passScore ? '恭喜通关！' : '未通过' }}
						</div>
						<div class="font_s40 font_weight m-t-10" :style="{ color: score >= passScore ? '#67C23A' : '#F56C6C' }">
							{{ score }} <span class="font_s16 color_999">/ {{ totalScore }}分</span>
						</div>
						<div class="color_666 m-t-10">
							答对 {{ correctCount }} 题，答错 {{ questions.length - correctCount }} 题
						</div>
						<div class="m-t-20">
							<el-button type="primary" @click="reviewExam" style="background-color: #163F88; border-color: #163F88;">
								查看解析
							</el-button>
							<el-button @click="$router.push('/pass')">返回首页</el-button>
						</div>
					</div>
				</el-card>

				<!-- 题目解析 -->
				<div v-if="showReview" class="text_l m-t-30" style="max-width: 800px; margin: 30px auto;">
					<div class="font_weight font_s18 m-b-20 main_color">题目解析</div>
					<el-card v-for="(q, qi) in questions" :key="qi" class="m-b-15"
						:class="{ 'review-correct': q.is_correct, 'review-wrong': !q.is_correct }">
						<div class="m-b-10">
							<el-tag size="mini" :type="getTypeTag(q.type)" class="m-r-10">{{ getTypeName(q.type) }}</el-tag>
							<el-tag size="mini" :type="q.is_correct ? 'success' : 'danger'">
								{{ q.is_correct ? '正确' : '错误' }}
							</el-tag>
						</div>
						<div class="font_weight m-b-10">{{ qi + 1 }}. {{ q.title }}</div>
						<div v-if="q.type == 'judge'" class="m-b-10">
							<div v-for="opt in judgeOptions" :key="opt.value" class="review-option"
								:class="{
									'review-option-correct': q.correct_answer === opt.value,
									'review-option-wrong': answers[q.id] === opt.value && q.correct_answer !== opt.value
								}">
								{{ opt.label }}. {{ opt.text }}
								<i v-if="q.correct_answer === opt.value" class="el-icon-check" style="color:#67C23A;"></i>
								<i v-if="answers[q.id] === opt.value && q.correct_answer !== opt.value" class="el-icon-close" style="color:#F56C6C;"></i>
							</div>
						</div>
						<div v-else class="m-b-10">
							<div v-for="(opt, oi) in q.options" :key="oi" class="review-option"
								:class="{
									'review-option-correct': isCorrectOption(q, opt.key),
									'review-option-wrong': isUserWrongOption(q, opt.key)
								}">
								{{ opt.key }}. {{ opt.value }}
								<i v-if="isCorrectOption(q, opt.key)" class="el-icon-check" style="color:#67C23A;"></i>
								<i v-if="isUserWrongOption(q, opt.key)" class="el-icon-close" style="color:#F56C6C;"></i>
							</div>
						</div>
						<div class="color_666 font_s14">
							<span class="font_weight">正确答案：</span>{{ q.correct_answer }}
							<span class="m-l-10 font_weight">你的答案：</span>
							<span :class="q.is_correct ? 'color_green' : 'color_red'">
								{{ Array.isArray(answers[q.id]) ? answers[q.id].join(',') : (answers[q.id] || '未作答') }}
							</span>
						</div>
						<div v-if="q.analysis" class="m-t-10 analysis-box">
							<span class="font_weight">解析：</span>{{ q.analysis }}
						</div>
					</el-card>
				</div>
			</div>
		</div>

		<el-dialog title="确认退出考试" :visible.sync="exitDialogVisible" width="420px" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" center>
			<div class="text_c">
				<i class="el-icon-warning-outline" style="font-size:48px;color:#E6A23C;"></i>
				<p class="font_s16 font_weight m-t-15">离开页面将自动交卷</p>
				<p class="color_666 m-t-10">确定后系统会按当前已作答内容提交；取消则继续留在当前考试页面。</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelLeaveExam">取消，继续答题</el-button>
				<el-button type="primary" :loading="submitting" @click="confirmLeaveExam"
					style="background-color:#163F88;border-color:#163F88;">确定交卷并退出</el-button>
			</span>
		</el-dialog>
		<br><br>
	</div>
</template>
<script>
export default {
	name: "PassExam",
	data() {
		return {
			loading: false,
			paperTitle: '',
			paperId: '',
			questionType: '',
			questions: [],
			answers: {},
			currentIndex: 0,
			timeLimit: 0,
			remainTime: 0,
			timer: null,
			submitting: false,
			submitted: false,
			score: 0,
			totalScore: 100,
			passScore: 60,
			correctCount: 0,
			showAnswerCard: false,
			showReview: false,
			exitDialogVisible: false,
			pendingRoute: null,
			allowRouteLeave: false,
			examEndAt: 0,
			judgeOptions: [
				{ value: 'A', label: 'A', text: '正确' },
				{ value: 'B', label: 'B', text: '错误' },
			],
		};
	},
	computed: {
		currentQuestion() {
			return this.questions[this.currentIndex] || {};
		},
		answeredCount() {
			return this.questions.filter(q => this.isAnswered(q.id)).length;
		}
	},
	activated() {
		this.paperId = this.$route.query.paper_id || '';
		this.paperTitle = this.$route.query.paper_title || '答题';
		this.questionType = this.$route.query.question_type || '';
		this.resetExam();
		this.loadQuestions();
		window.addEventListener('beforeunload', this.handleBeforeUnload);
	},
	deactivated() {
		window.removeEventListener('beforeunload', this.handleBeforeUnload);
		this.clearTimer();
	},
	beforeDestroy() {
		window.removeEventListener('beforeunload', this.handleBeforeUnload);
		this.clearTimer();
	},
	beforeRouteLeave(to, from, next) {
		if (this.allowRouteLeave || !this.hasActiveExam()) {
			next();
			return;
		}
		this.pendingRoute = to;
		this.exitDialogVisible = true;
		next(false);
	},
	methods: {
		resetExam() {
			this.questions = [];
			this.answers = {};
			this.currentIndex = 0;
			this.submitted = false;
			this.submitting = false;
			this.showReview = false;
			this.score = 0;
			this.correctCount = 0;
			this.exitDialogVisible = false;
			this.pendingRoute = null;
			this.allowRouteLeave = false;
			this.examEndAt = 0;
			this.clearTimer();
		},
		loadQuestions() {
			this.loading = true;
			this.$api.authPass.getPaperQuestions({ paper_id: this.paperId, question_type: this.questionType }).then((res) => {
				if (res.code == 1) {
					const typeMap = {1: 'judge', 2: 'single', 3: 'multi', 4: 'uncertain'};
					const rawQuestions = res.data.questions || [];
					if (rawQuestions.length === 0) {
						this.$message.warning('试卷暂无可用题目，请稍后再试');
						this.$router.push('/pass');
						return;
					}
					this.questions = rawQuestions.map(q => ({
						id: q.id,
						type: typeMap[q.type] || q.type,
						title: q.name || q.title,
						options: q.items || q.options || [],
						score: q.score,
						analysis: q.analysis || '',
					}));
					const paper = res.data.paper || {};
					this.timeLimit = paper.time_limit || res.data.time_limit || 0;
					this.totalScore = paper.total_score || res.data.total_score || 100;
					this.passScore = paper.pass_score || res.data.pass_score || 60;
					this.restoreExamCache();
					if (this.timeLimit > 0) {
						if (!this.examEndAt) {
							this.remainTime = this.timeLimit * 60;
							this.examEndAt = Date.now() + this.remainTime * 1000;
						}
						this.startTimer();
					}
					this.saveExamCache();
				} else {
					this.$message.error(res.info || '获取试题失败');
					this.$router.push('/pass');
				}
			}).catch(() => {
				this.$message.error('获取试题失败');
			}).finally(() => {
				this.loading = false;
			});
		},
		selectAnswer(qid, value) {
			this.$set(this.answers, qid, value);
			this.saveExamCache();
		},
		toggleMultiAnswer(qid, key) {
			let current = this.answers[qid] || [];
			if (!Array.isArray(current)) current = [];
			const idx = current.indexOf(key);
			if (idx > -1) {
				current.splice(idx, 1);
			} else {
				current.push(key);
				current.sort();
			}
			this.$set(this.answers, qid, [...current]);
			this.saveExamCache();
		},
		isAnswered(qid) {
			const a = this.answers[qid];
			if (Array.isArray(a)) return a.length > 0;
			return !!a;
		},
		prevQuestion() {
			if (this.currentIndex > 0) {
				this.currentIndex--;
				this.saveExamCache();
			}
		},
		nextQuestion() {
			if (this.currentIndex < this.questions.length - 1) {
				this.currentIndex++;
				this.saveExamCache();
			}
		},
		jumpToQuestion(idx) {
			this.currentIndex = idx;
			this.showAnswerCard = false;
			this.saveExamCache();
		},
		startTimer() {
			this.clearTimer();
			this.timer = setInterval(() => {
				if (this.examEndAt) {
					this.remainTime = Math.max(0, Math.ceil((this.examEndAt - Date.now()) / 1000));
				}
				if (this.remainTime > 0) {
					this.saveExamCache();
				} else {
					this.clearTimer();
					this.$message.warning('考试时间到，自动交卷！');
					this.doSubmit({ silent: true, redirectPath: '/pass' }).catch(() => {
						this.$message.error('自动交卷失败，请手动提交或重新进入考试');
					});
				}
			}, 1000);
		},
		clearTimer() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
		formatTime(s) {
			const m = Math.floor(s / 60);
			const sec = s % 60;
			return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
		},
		confirmSubmit() {
			if (this.submitting) return;
			const unanswered = this.questions.length - this.answeredCount;
			if (unanswered > 0) {
				this.$confirm(`还有 ${unanswered} 题未作答，确定交卷吗？`, '提示', {
					confirmButtonText: '确定交卷',
					cancelButtonText: '继续答题',
					type: 'warning'
				}).then(() => {
					this.doSubmit();
				}).catch(() => {});
			} else {
				this.$confirm('确定要交卷吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.doSubmit();
				}).catch(() => {});
			}
		},
		doSubmit(options = {}) {
			if (this.submitting) return Promise.resolve();
			this.submitting = true;
			this.clearTimer();
				// 构造答案数组格式（后端期望 [{question_id, answer}]）
				const answerArr = this.questions.map(q => {
					const a = this.answers[q.id];
					return {
						question_id: q.id,
						answer: Array.isArray(a) ? a.join(',') : (a || ''),
					};
				});
				return this.$api.authPass.submitExam({
					paper_id: this.paperId,
					question_type: this.questionType,
					answers: JSON.stringify(answerArr),
					time_used: this.timeLimit > 0 ? (this.timeLimit * 60 - this.remainTime) : 0,
				}).then((res) => {
					if (res.code == 1) {
						this.clearExamCache();
						this.score = res.data.user_score || res.data.score || 0;
						this.correctCount = res.data.correct_count || 0;
						this.totalScore = res.data.total_score || 100;
						this.passScore = this.passScore || 60;
						// 标记每题是否正确（后端返回answers数组）
						if (res.data.answers && Array.isArray(res.data.answers)) {
							res.data.answers.forEach(r => {
								const q = this.questions.find(q => q.id == r.question_id);
								if (q) {
									q.is_correct = r.is_correct == 1;
									q.correct_answer = r.right_answer;
									q.analysis = r.analysis || q.analysis;
								}
							});
						}
						this.submitted = true;
						this.allowRouteLeave = true;
						window.removeEventListener('beforeunload', this.handleBeforeUnload);
						if (options.redirectPath) {
							this.$router.replace(options.redirectPath);
						}
				} else {
					if (!options.silent) this.$message.error(res.info || '提交失败');
					return Promise.reject(res);
				}
			}).catch((error) => {
				if (!options.silent) this.$message.error('提交失败，请重试');
				return Promise.reject(error);
			}).finally(() => {
				this.submitting = false;
			});
		},
		hasActiveExam() {
			return !this.loading && !this.submitted && this.questions.length > 0 && !this.submitting;
		},
		handleBeforeUnload(event) {
			if (!this.hasActiveExam()) return;
			this.saveExamCache();
			event.preventDefault();
			event.returnValue = '离开页面将终止本次考试并自动交卷，是否确认退出？';
			return event.returnValue;
		},
		examCacheKey() {
			return `pass_exam_cache_${this.paperId}_${localStorage.getItem('u_token') || 'guest'}`;
		},
		saveExamCache() {
			if (!this.paperId || this.submitted || this.questions.length === 0) return;
			const payload = {
				paperId: this.paperId,
				paperTitle: this.paperTitle,
				answers: this.answers,
				currentIndex: this.currentIndex,
				remainTime: this.remainTime,
				examEndAt: this.examEndAt,
				timeLimit: this.timeLimit,
				updatedAt: Date.now(),
			};
			try {
				localStorage.setItem(this.examCacheKey(), JSON.stringify(payload));
			} catch (e) {
				return false;
			}
			return true;
		},
		restoreExamCache() {
			try {
				const raw = localStorage.getItem(this.examCacheKey());
				if (!raw) return;
				const cache = JSON.parse(raw);
				if (!cache || cache.paperId != this.paperId) return;
				this.answers = cache.answers || {};
				this.currentIndex = Math.min(Math.max(parseInt(cache.currentIndex || 0, 10), 0), Math.max(this.questions.length - 1, 0));
				this.examEndAt = parseInt(cache.examEndAt || 0, 10);
				if (this.examEndAt) {
					this.remainTime = Math.max(0, Math.ceil((this.examEndAt - Date.now()) / 1000));
				} else {
					this.remainTime = parseInt(cache.remainTime || 0, 10);
				}
			} catch (e) {
				this.clearExamCache();
			}
		},
		clearExamCache() {
			if (!this.paperId) return;
			try {
				localStorage.removeItem(this.examCacheKey());
			} catch (e) {
				return false;
			}
			return true;
		},
		cancelLeaveExam() {
			this.exitDialogVisible = false;
			this.pendingRoute = null;
		},
		confirmLeaveExam() {
			const target = this.pendingRoute;
			this.doSubmit({ silent: true }).then(() => {
				this.exitDialogVisible = false;
				this.allowRouteLeave = true;
				this.pendingRoute = null;
				if (target) {
					this.$router.push(target.fullPath || target.path || '/pass');
				}
			}).catch(() => {
				this.$message.error('自动交卷失败，请重试');
			});
		},
		reviewExam() {
			this.showReview = true;
		},
		getTypeName(type) {
			const map = { judge: '判断题', single: '单选题', multi: '多选题', uncertain: '不定项' };
			return map[type] || type;
		},
		getTypeTag(type) {
			const map = { judge: '', single: 'success', multi: 'warning', uncertain: 'danger' };
			return map[type] || '';
		},
		isCorrectOption(q, key) {
			return this.splitAnswerKeys(q.correct_answer).includes(key);
		},
		isUserWrongOption(q, key) {
			const ua = this.answers[q.id];
			const uaArr = Array.isArray(ua) ? ua : (ua ? [ua] : []);
			const caArr = this.splitAnswerKeys(q.correct_answer);
			return uaArr.includes(key) && !caArr.includes(key);
		},
		splitAnswerKeys(value) {
			return String(value || '')
				.toUpperCase()
				.replace(/[，、；;／/|\s]+/g, ',')
				.split(',')
				.map(item => item.trim())
				.filter(Boolean);
		}
	}
};
</script>
<style scoped>
.exam-header {
	background: white;
	padding: 15px 20px;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.question-card {
	border-radius: 8px;
}
.question-title {
	line-height: 1.8;
}
.option-item {
	display: flex;
	align-items: center;
	padding: 12px 16px;
	margin-bottom: 10px;
	border: 2px solid #eee;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s;
}
.option-item:hover {
	border-color: #163F88;
	background: #f0f5ff;
}
.option-selected {
	border-color: #163F88;
	background: #e8f0fe;
}
.option-label {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #f0f0f0;
	margin-right: 12px;
	font-weight: bold;
	font-size: 14px;
	flex-shrink: 0;
}
.option-selected .option-label {
	background: #163F88;
	color: white;
}
.answer-card-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
.answer-card-item {
	width: 36px;
	height: 36px;
	line-height: 36px;
	text-align: center;
	border: 1px solid #ddd;
	border-radius: 4px;
	cursor: pointer;
	font-size: 13px;
	transition: all 0.2s;
}
.answer-card-item:hover {
	border-color: #163F88;
}
.answer-card-item.answered {
	background: #163F88;
	color: white;
	border-color: #163F88;
}
.answer-card-item.current {
	border-color: #E6A23C;
	box-shadow: 0 0 0 2px rgba(230,162,60,0.3);
}
.result-card {
	border-radius: 12px;
}
.review-correct {
	border-left: 4px solid #67C23A;
}
.review-wrong {
	border-left: 4px solid #F56C6C;
}
.review-option {
	padding: 6px 12px;
	margin-bottom: 4px;
	border-radius: 4px;
}
.review-option-correct {
	background: #f0f9eb;
	color: #67C23A;
}
.review-option-wrong {
	background: #fef0f0;
	color: #F56C6C;
}
.analysis-box {
	background: #fdf6ec;
	padding: 10px 15px;
	border-radius: 6px;
	color: #E6A23C;
	font-size: 14px;
}
.color_green { color: #67C23A; }
.color_red { color: #F56C6C; }
</style>
